/**
 * Shared style utilities for the Clawer design system
 */
import type { BadgeStyle } from './types';

/**
 * Badge colors based on relationship type (Clawer categories)
 */
export const relationshipBadgeStyles: Record<string, BadgeStyle> = {
  inner_circle: { bg: 'bg-primary/20', text: 'text-primary-dark', label: 'Inner Circle' },
  active: { bg: 'bg-green-500/20', text: 'text-green-700', label: 'Active' },
  casual: { bg: 'bg-gray-500/20', text: 'text-gray-700', label: 'Casual' },
  dormant: { bg: 'bg-blue-500/20', text: 'text-blue-700', label: 'Dormant' },
  // Generic fallbacks
  friend: { bg: 'bg-pink-500/20', text: 'text-pink-700', label: 'Friend' },
  colleague: { bg: 'bg-purple-500/20', text: 'text-purple-700', label: 'Colleague' },
  family: { bg: 'bg-orange-500/20', text: 'text-orange-700', label: 'Family' },
};

export function getBadgeStyle(relationship: string | null): BadgeStyle {
  if (!relationship) return relationshipBadgeStyles.casual;
  const key = relationship.toLowerCase().replace(/\s+/g, '_');
  return relationshipBadgeStyles[key] || { bg: 'bg-gray-500/20', text: 'text-gray-700', label: relationship };
}
